export * from './secured-dance-school-element.directive';
export * from './secured-dance-school-element.module';
